import { Component, OnInit, OnDestroy } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { environment } from '../../environments/environment';
import { AuthService, User } from '../shared/auth.service';
import { Subscription, Observable } from 'rxjs';

@Component({
  selector: 'app-generate-reports',
  templateUrl: './generate-reports.component.html',
  styleUrls: ['./generate-reports.component.css']
})
export class GenerateReportsComponent implements OnInit, OnDestroy {

  baseCloudFunctionUrl = environment.production ?
                          'https://us-central1-kofc-ohio.cloudfunctions.net' :
                          'https://us-central1-kofc-ohio-dev.cloudfunctions.net';

  private subscriptions = new Subscription();
  private user: Observable<User>;
  isAdmin: boolean;
  isReportAdmin: boolean;
  isCommunityDirector: boolean;
  isFaithDirector: boolean;
  isFamilyDirector: boolean;
  isLifeDirector: boolean;
  isMembershipDirector: boolean;
  isAuthenticated = false;

  isGeneratingReport = false;

  selectedFraternalYear = environment.fraternalYear;

  constructor(private http: HttpClient,
              private afAuth: AngularFireAuth,
              private authService: AuthService) {
    this.user = this.authService.getUser();
  }

  ngOnInit() {
    this.subscriptions.add(this.user.subscribe(user => {
      if (user) {
        this.isAuthenticated = true;
        this.isAdmin = user.roles.admin;
        this.isReportAdmin = user.roles.reportAdmin;
        this.isCommunityDirector = user.roles.communityDirector;
        this.isFaithDirector = user.roles.faithDirector;
        this.isFamilyDirector = user.roles.familyDirector;
        this.isLifeDirector = user.roles.lifeDirector;
        this.isMembershipDirector = user.roles.membershipDirector;
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  generateCouncilReport(councilId: string) {
    if (councilId) {
      this.isGeneratingReport = true;
      this.afAuth.currentUser
      .then((user) => user.getIdToken(true))
      .then((token) => {
        this.http.get(`${this.baseCloudFunctionUrl}/generateCouncilReport?council=${councilId}&fraternalyear=${this.selectedFraternalYear}`,
                {
                  headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
                  responseType: 'blob'
                }).subscribe(response => {
                  const d = new Date();
                  const filename = `council-${councilId}-activities-${d.toISOString().split('.')[0].replace(/:/g, '_')}.csv`;
                  saveAs(response, filename);
                  this.isGeneratingReport = false;
                },
                error => {
                  this.isGeneratingReport = false;
                  console.log('error', error);
                });
      });
    }
  }

  consoleLogMembershipGrowthData(googleSheetID: string) {
    if(googleSheetID) {
      this.isGeneratingReport = true;
      this.afAuth.currentUser
      .then((user) => user.getIdToken(true))
      .then((token) => {
        this.http.get(`http://localhost/getSheet?id=${googleSheetID}&range=Sheet1`, {responseType: 'text'}).subscribe(response => {
          console.log(response);
          this.isGeneratingReport = false;
        },
        error => {
          this.isGeneratingReport = false;
          console.log('error', error);
        });
      });
    }
  }

  importMembershipGrowthData(googleSheetID: string) {
    if(googleSheetID) {
      this.isGeneratingReport = true;
      this.afAuth.currentUser
      .then((user) => user.getIdToken(true))
      .then((token) => {
        this.http.get(`http://localhost/getSheet?id=${googleSheetID}&range=Sheet1`, {responseType: 'text'}).subscribe(response => {
          console.log(response);

          this.http.post(`${this.baseCloudFunctionUrl}/importMembershipGrowthData`, response, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
            responseType: 'text'
          }).subscribe(postResponse => {
            console.log(postResponse);
            this.isGeneratingReport = false;
          },
          postError => {
            this.isGeneratingReport = false;
            console.log('error', postError);
          });
        },
        error => {
          this.isGeneratingReport = false;
          console.log('error', error);
        });
      });
    }
  }

  generateDirectorReport(programGroup: string) {
    this.afAuth.currentUser
    .then((user) => user.getIdToken(true))
    .then((token) => {
      this.isGeneratingReport = true;
      // tslint:disable-next-line:max-line-length
      this.http.get(`${this.baseCloudFunctionUrl}/generateDirectorReport?director=${programGroup}&fraternalyear=${this.selectedFraternalYear}`,
                        {
                          headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
                          responseType: 'blob'
                        }).subscribe(response => {
                          const d = new Date();
                          const filename = `${programGroup}-activities-${d.toISOString().split('.')[0].replace(/:/g, '_')}.csv`;
                          saveAs(response, filename);
                          this.isGeneratingReport = false;
                        },
                        error => {
                          this.isGeneratingReport = false;
                          console.log('error', error);
                        });
    });
  }

  generateOverallReport() {
    this.isGeneratingReport = true;
    this.http.get(`${this.baseCloudFunctionUrl}/generateReport?fraternalyear=${this.selectedFraternalYear}`,
                        {
                          responseType: 'blob'
                        }).subscribe(response => {
                          const d = new Date();
                          const filename = `overall-activities-report-${d.toISOString().split('.')[0].replace(/:/g, '_')}.csv`;
                          saveAs(response, filename);
                          this.isGeneratingReport = false;
                        },
                        error => {
                          this.isGeneratingReport = false;
                          console.log('error', error);
                        });
  }
}
